// extracted by mini-css-extract-plugin
module.exports = {"shopCategory-wrappr":"shopCategory_shopCategory-wrappr__zJSfM"};